module.exports = __webpack_public_path__ + "img/download-duotone.e4583d6c.svg";